module.exports = __webpack_public_path__ + "static/img/109_TO8_1801.0bc3fbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/109_TO8_1801.jpg
// module id = mDtZ
// module chunks = 0